import { MDBContainer } from "mdb-react-ui-kit";
import { useState, useEffect } from "react";

//common component
import Header from "../../components/header/header-one";
import Sidebar from "../../components/sidebar/sidebar-one";

//component
import MerchantListing from "./component/merchant.listing";
import CreateModalBox from "./component/create.modalbox";
import EditModalBox from "./component/edit.modalbox";
import Gif from "../../assets/fonts/loader/loader.gif";

//api service
import apiServices from "../../services/api.services";
import useWindowDimensions from "../../components/common/window-dimension";

export default function Merchant() {
  const [loader, setLoader] = useState(false);

  //data for api
  const [type, setType] = useState("merchant"); //control role
  const [start, setStart] = useState(0); //paginate
  const [length, setLength] = useState(10); //paginate
  const [order, setOrder] = useState("desc"); // asc or desc
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(); //filter date
  const [endDate, setEndDate] = useState(); //filter date
  //handle modalbox
  const [createModal, setCreateModal] = useState(false);
  const [actionValue, setActionValue] = useState(false);
  const [infoModalBoxData, setInfoModalBoxData] = useState({});
  const [selectedId, setSelectedId] = useState("selectedId");
  //date for render
  const [listingData, setListingData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [displayRecords, setDisplayRecords] = useState(0);
  //handle apply filter
  const [handleApplyFilter, setHandleApplyFilter] = useState(false);
  const { height, width } = useWindowDimensions();

  useEffect(() => {
    if (width >= "767") {
      setOpenSideBar(true);
    } else {
      setOpenSideBar(false);
    }
  }, [width]);

  const getListing = async () => {
    const response = await apiServices.getAllListing({
      api_name: "user",
      type,
      search,
      order,
      startDate,
      endDate,
      length,
      start,
    });
    if (response) {
      setLoader(false);

      setListingData(response.aaData);
      setTotalRecords(response.iTotalRecords);
      setDisplayRecords(response.iTotalDisplayRecords);
    }
  };

  useEffect(() => {
    getListing();
    if (search === "") {
      // setLoader(true);
    }
  }, [search, length, handleApplyFilter, start]);

  const [openSideBar, setOpenSideBar] = useState(true);

  const handleOpenSideBar = () => {
    setOpenSideBar(!openSideBar);
  };

  const getInfoDetail = async () => {
    const response = await apiServices.getUserInfo(selectedId);
    if (response) {
      setInfoModalBoxData(response);
    }
  };

  const createAble = () => {
    setCreateModal(!createModal);
  };
  const handleCloseModal = () => {
    setInfoModalBoxData({});
    setActionValue(false);
    setSelectedId("selectedId");
  };

  const handleActionChange = (selectedDataRow) => {
    setActionValue(!actionValue);
    setSelectedId(selectedDataRow.id);
  };

  useEffect(() => {
    if (selectedId >= 0) {
      getInfoDetail();
    }
  }, [selectedId]);

  return (
    <MDBContainer className="main-container" breakpoint="none">
      <div className="grid-container">
        <Sidebar isOpen={openSideBar} handleSideBar={handleOpenSideBar} />
        {actionValue && Object.keys(infoModalBoxData).length > 0 && (
          <EditModalBox
            show={true}
            getListing={getListing}
            selectedData={infoModalBoxData}
            close={handleCloseModal}
          />
        )}
        {createModal && (
          <CreateModalBox
            show={true}
            title="Create Merchant"
            close={createAble}
            getListing={getListing}
            type={type}
          />
        )}
        <div className="page-container">
          <Header handleSideBar={handleOpenSideBar} />
          {loader ? (
            <div className="loader">
              <img src={Gif} />
            </div>
          ) : (
            <MerchantListing
              length={length}
              start={start}
              createAble={createAble}
              listingData={listingData}
              totalRecords={totalRecords}
              displayRecords={displayRecords}
              setListingData={setListingData}
              setSearch={setSearch}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setOrder={setOrder}
              setLength={setLength}
              setStart={setStart}
              getListing={getListing}
              handleActionChange={handleActionChange}
            />
          )}
        </div>
      </div>
    </MDBContainer>
  );
}
